import { useEffect } from 'react';
import { Route, useLocation } from 'react-router-dom';

import { datadogRum } from '@datadog/browser-rum';

import AmplitudeTracker from 'common/services/trackers/amplitude';
import DatadogTracker from 'common/services/trackers/datadog';
import FirebaseTracker from 'common/services/trackers/firebase';
import KochavaTracker from 'common/services/trackers/kochava';
import SingularTracker from 'common/services/trackers/singular';

import { CondensedWrapper } from 'common/components';
import ErrorNotification from 'common/components/error/error-notification';
import { RouteType } from 'common/config/routes/routes.type';
import { AppTypeConfig, getAppTypeConfig } from 'common/helpers/routing';
import { IconService } from 'common/services';

// INIT TRACKERS
DatadogTracker.init();
FirebaseTracker.init();
KochavaTracker.init();
AmplitudeTracker.init();
SingularTracker.init();

// ICON SERVICE
IconService.init();

const App = () => {
  const location = useLocation();
  const appTypeConfig: AppTypeConfig = getAppTypeConfig();
  const Layout = appTypeConfig.LayoutToUse;

  useEffect(() => {
    datadogRum.startView({ name: location.pathname });
  }, [location.pathname]);

  return (
    <CondensedWrapper>
      <ErrorNotification>
        <Layout>
          {appTypeConfig.routes.map((route: RouteType) => {
            return <Route key={route.path} path={route.path} element={<route.component />} />;
          })}
        </Layout>
      </ErrorNotification>
    </CondensedWrapper>
  );
};

export default App;
